import React from 'react';
import { Heading } from '../../Heading/Heading';
import { PostsEditorWithUploadAndAttachedFiles } from '../editors/PostsEditorWithUploadAndAttachedFiles';
import { PostsEditor } from '../editors/PostsEditor';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import IForm from '../../../../types/IForm';
import { PostFirst, PostReply, PostTypes, isPostFirst } from '../Post.types';

type PostUpdateFormProps = {
  type: PostTypes;
  currentForm: IForm;
  post?: PostFirst | PostReply;
  headingHierarchy: number;
};

export function PostUpdateForm({ type, currentForm, post, headingHierarchy }: PostUpdateFormProps) {
  const { t } = useSonTranslation('Posts');

  return (
    <>
      <Heading className="posts__heading" hierarchy={headingHierarchy}>
        {t(`default.heading.edit.${type}`)}
      </Heading>
      {type === 'thread'
        ? (
            <PostsEditorWithUploadAndAttachedFiles
              form={currentForm}
              type={type}
              attachments={post && isPostFirst(post) ? post.attachments : undefined}
              attachedFileUpdateOrder={post && isPostFirst(post) ? post.attachedFileUpdateOrder : undefined}
              postId={post?.id}
            />
          )
        : (
            <PostsEditor form={currentForm} type={type} autoFocus />
          )}
    </>
  );
}
